/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neat_Crisp_Fox_LimpInputs */

const en_neat_crisp_fox_limp = /** @type {(inputs: Neat_Crisp_Fox_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Imports`)
};

const de_neat_crisp_fox_limp = /** @type {(inputs: Neat_Crisp_Fox_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Imports`)
};

/**
* | output |
* | --- |
* | "Active Imports" |
*
* @param {Neat_Crisp_Fox_LimpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const neat_crisp_fox_limp = /** @type {((inputs?: Neat_Crisp_Fox_LimpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Crisp_Fox_LimpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_neat_crisp_fox_limp(inputs)
	return de_neat_crisp_fox_limp(inputs)
});